import { createRequestActionTypes, createActionType } from '../../helpers'

export const CLEAR_DEVICE = createActionType('DEVICES', 'CLEAR_DEVICE')
export const FETCH_DEVICES = createRequestActionTypes('DEVICES', 'DEVICES')



// WEBPACK FOOTER //
// ./src/containers/DeviceSelector/constants.js